/**
 * @generated SignedSource<<c6d091e03044504b2f77eff072715b91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionProblemEventDescriptionList_promotion$data = {
  readonly problemEvent: {
    readonly count: number;
    readonly durationDays: number | null;
    readonly durationHours: number | null;
    readonly offsetHours: number;
  } | null;
  readonly " $fragmentType": "PromotionProblemEventDescriptionList_promotion";
};
export type PromotionProblemEventDescriptionList_promotion$key = {
  readonly " $data"?: PromotionProblemEventDescriptionList_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionProblemEventDescriptionList_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionProblemEventDescriptionList_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionProblemEvent",
      "kind": "LinkedField",
      "name": "problemEvent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationHours",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offsetHours",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "4354ff005575784ad00e482483dc3f2f";

export default node;
